/***
 * Created on 2024/3/26
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import QnapAuthQrcodeVerificationComponent from "./qnap_auth_qrcode_verification_component";
import QnapAuthApprovalVerificationComponent from "./qnap_auth_approval_verification_component";
import QnapAuthByVerifyVerificationComponent from "./qnap_auth_by_verify_verification_component";

function QnapAuthVerificationComponent({method, twoStepInfo, isObserver, onLaunchQnapAuth, otherWay, signout}) {
    return (
        <>
            {method === 'qrcode' && <QnapAuthQrcodeVerificationComponent isObserver={isObserver} onLaunchQnapAuth={onLaunchQnapAuth} otherWay={otherWay} signout={signout} twoStepInfo={twoStepInfo}/>}
            {method === 'approval' && <QnapAuthApprovalVerificationComponent isObserver={isObserver} onLaunchQnapAuth={onLaunchQnapAuth} otherWay={otherWay} signout={signout} twoStepInfo={twoStepInfo}/>}
            {method === 'verification' && <QnapAuthByVerifyVerificationComponent isObserver={isObserver} onLaunchQnapAuth={onLaunchQnapAuth} otherWay={otherWay} signout={signout} twoStepInfo={twoStepInfo}/>}
        </>
    );
}

export default QnapAuthVerificationComponent;